import React from 'react';
import HierarchySection from '../components/HierarchySection';

const Hierarchy: React.FC = () => {
  return (
    <div className="pt-20">
      <HierarchySection />
    </div>
  );
};

export default Hierarchy;

